namespace Vit.Administration {
    export interface UserTenantRoleUpdateRequest extends Serenity.ServiceRequest {
        UserID?: number;
        Entities?: UserTenantRoleDefinition[];
    }
}